import { render, staticRenderFns } from "./UnidadMedidaDetalle.vue?vue&type=template&id=614ad2cf"
import script from "./UnidadMedidaDetalle.vue?vue&type=script&lang=js"
export * from "./UnidadMedidaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports